module.exports = __webpack_public_path__ + "img/PD2017489884331245568.e6399f5a.png";